<template>
  <el-container>
    <aside-menu></aside-menu>
    <el-container>
      <el-header>
        <header-bar></header-bar>
      </el-header>
      <el-main>
        <router-view :key="key" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AsideMenu from "./components/menu/AsideMenu";
import HeaderBar from "./components/header/HeaderBar";
export default {
  name: "DefaultLayout",
  components: { AsideMenu, HeaderBar },
  computed: {
    key() {
      return this.$route.path;
    }
  }
};
</script>
